import * as React from 'react'
import * as plume from '@ulule/owl-kit-components/next'

import { Container } from '../../_shared/Container'
import { DISCOVER_URL, NEWSLETTER_URL, SOCIAL_LINKS } from '../content'
import { FramedImage } from '../components/FramedImage'
import ululeTeam from '../assets/join/ulule-team.jpg?url'
import styles from './Join.module.css'

export function Join(): React.ReactElement {
  return (
    <section className={styles.join} id="travailler">
      <Container>
        <div className={styles.join__head}>
          <div>
            <span className={styles.join__badge}>Nous rejoindre</span>
            <h2 className={styles.join__title}>Travailler chez Ulule</h2>
          </div>
          <FramedImage src={ululeTeam} alt="L'équipe Ulule" className={styles.join__illu} />
        </div>

        <div className={styles.join__grid}>
          <div className={styles.panel}>
            <p className={styles.panelLead__intro}>
              On n'a pas de postes ouverts en ce moment. <em>Mais</em> : on est toujours ravis de rencontrer
              de nouveaux talents qui partagent notre passion.
            </p>
            <p className={styles.panelLead__body}>
              On fait les choses un peu différemment ici — pas de service RH, pas de formulaire à remplir, pas
              de process en 12 étapes. Si tu es maker dans l'âme et que tu veux bosser avec nous, tu sais déjà
              comment nous trouver — on est là 👋
            </p>
          </div>
          <div className={styles.join__side}>
            <div className={styles.mini}>
              <p className={styles.mini__key}>Nous suivre</p>
              <p className={styles.mini__body}>
                Retrouvez-nous sur{' '}
                <a href={SOCIAL_LINKS.linkedin} target="_blank" rel="noopener noreferrer">
                  LinkedIn
                </a>{' '}
                &amp;{' '}
                <a href={SOCIAL_LINKS.instagram} target="_blank" rel="noopener noreferrer">
                  Instagram
                </a>
              </p>
            </div>
            <div className={styles.mini}>
              <p className={styles.mini__key}>Ne rien rater</p>
              <p className={styles.mini__body}>
                Pour suivre nos aventures, <a href={NEWSLETTER_URL}>inscrivez-vous à la Newsletter Ulule</a>
              </p>
            </div>
          </div>
        </div>

        <div className={styles.join__cta}>
          <p className={styles.join__ctaKey}>Ensemble, on développe au quotidien</p>
          <h3 className={styles.join__ctaTitle}>
            La meilleure plateforme pour lancer ou développer vos projets&nbsp;!
          </h3>
          <plume.RoundButton
            as="a"
            href={DISCOVER_URL}
            color="yellow"
            size="big"
            suffixIcon={<plume.glyphs.stroke.ArrowRight size={16} />}
          >
            Découvrir les services Ulule
          </plume.RoundButton>
        </div>
      </Container>
    </section>
  )
}
